import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
	container: {
		"& > *": {
			marginRight: theme.spacing(0.5)
		}
	},
	divider: {
		...ColorUtil.getBackgroundAndContrastColor(colors.blue[100]),
		width: "100%"
	}
}))

export default useStyles
